/**
 * Zone flags simplifiés pour compatibilité Dynatrace
 */

// Configuration minimale pour éviter les conflits avec Dynatrace
// Désactiver les timers seulement hors environnement de test (zone.js/testing en a besoin)
if (!('__karma__' in window)) {
  (window as any).__Zone_disable_timers = true;
}
(window as any).__Zone_disable_ZoneAwarePromise = false; // Garder les Promises pour Angular
(window as any).__Zone_enable_cross_context_check = true; // Compatibilité bibliothèques tierces
(window as any).__Zone_disable_customElements = true; // Désactiver le patch des Custom Elements pour Clarity
(window as any).__Zone_disable_requestAnimationFrame = true; // Désactiver le patch requestAnimationFrame
(window as any).__Zone_disable_on_property = true; // Désactiver le patch des propriétés "on" (onclick, etc.)

// Événements non patchés pour performance
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'resize'];

// Protection simplifiée contre les erreurs Zone.js/Dynatrace
const originalConsoleError = console.error;
console.error = function (...args: any[]) {
  const message = args.join(' ');

  // Préserver les logs de l'HttpInterceptor
  if (message.includes('[HttpInterceptor]') || message.includes('[sbvp_gui]')) {
    return originalConsoleError.apply(console, args);
  }

  // Bloquer les erreurs Zone.js et NgRx courantes
  if (
    message.includes('can not transition to') ||
    message.includes('Cannot assign to read only property') ||
    (message.includes('caller') && message.includes('callee'))
  ) {
    return; // Ignorer silencieusement
  }

  return originalConsoleError.apply(console, args);
};

console.log('[Zone-flags] 🛡️ Protection simplifiée activée');
